import React from 'react';
import { useNavigate } from 'react-router-dom';

const AboutSection = () => {
  const navigate = useNavigate();
  return (
    <section className="about-section">
      <div className="container about-container">
        
        {/* Left Side: Image & Badge */}
        <div className="about-visual">
          <div className="about-image-wrapper">
            <img src="https://images.pexels.com/photos/34324342/pexels-photo-34324342.jpeg" alt="Making Authentic Chai" className="about-img" />
            <div className="about-badge">
              <span className="badge-year">2022</span>
              <span className="badge-text">Est Year</span>
            </div>
          </div>
        </div>

        {/* Right Side: Text & Features */}
        <div className="about-content">
          <p className="about-subtitle">OUR STORY</p>
          <h2 className="about-title">About ChaiY</h2>
          <p className="about-description">
            ChaiY was started in 2022 to innovate in the food industry to serve authentic food with quality ingredients. 
            Our mission is to bring the authentic taste of Indian chai to every home.
          </p>

          <div className="about-features">
            <div className="feature-item">
              <div className="feature-icon">
                {/* Leaf Icon */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 20A7 7 0 0 1 9.8 6.1C15.5 5 17 4.48 19 2c1 2 2 4.18 2 8 0 5.5-4.78 10-10 10Z"/><path d="M2 21c0-3 1.85-5.36 5.08-6C9.5 14.52 12 13 13 12"/></svg>
              </div>
              <div className="feature-text">
                <h4>Quality Ingredients</h4>
                <p>Only the finest tea leaves and authentic spices</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                {/* Award Icon */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89 17 22l-5-3-5 3 1.523-9.11"/></svg>
              </div>
              <div className="feature-text">
                <h4>Authentic Taste</h4>
                <p>Traditional recipes crafted over time</p>
              </div>
            </div>

            <div className="feature-item">
              <div className="feature-icon">
                {/* Heart Icon */}
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M19 14c1.49-1.46 3-3.21 3-5.5A5.5 5.5 0 0 0 16.5 3c-1.76 0-3 .5-4.5 2-1.5-1.5-2.74-2-4.5-2A5.5 5.5 0 0 0 2 8.5c0 2.3 1.5 4.05 3 5.5l7 7Z"/></svg>
              </div>
              <div className="feature-text">
                <h4>Made with Love</h4>
                <p>Every blend crafted with passion and care</p>
              </div>
            </div>
          </div>

          <button onClick={() => navigate('/about')} className="btn-primary" style={{ display: 'inline-flex', alignItems: 'center', gap: '8px' }}>
            Learn More About Us 
            <span>→</span>
          </button>
        </div>

      </div>
    </section>
  );
};

export default AboutSection;